import { usePermissions } from "./usePermissions";

// <Guard privilege="CODE">...</Guard>
// <Guard privileges={["A","B"]} any>...</Guard>   // any (OR) logic
// <Guard privileges={["A","B"]} all>...</Guard>   // all (AND) logic

const Guard = ({
  privilege,
  privileges = [],
  any = true,
  all = false,
  children,
  fallback = null,
}) => {
  const { can, canAny } = usePermissions();

  if (privilege) {
    return can(privilege) ? children : fallback;
  }

  if (privileges && privileges.length) {
    if (all) {
      // all privileges required
      const hasAll = privileges.every((p) => can(p));
      return hasAll ? children : fallback;
    }

    // default: any (OR)
    return canAny(privileges) ? children : fallback;
  }

  return null;
};

export default Guard;
